@if (data) {
  <div class="content-wrapper">
    @if (data.type === 'blog') {
      <img [src]="data.detailObj.image" alt=""
        onError="this.src='../../../assets/images/cakes.png'" />
    }
    @if (data.type === 'news') {
      <img [src]="data.detailObj.image_url" alt=""
        onError="this.src='../../../assets/images/cakes.png'" />
    }
    <h2 class="card-title">
      @if (data.type === 'blog') {
        {{ data.detailObj?.title }}
      }
      @if (data.type === 'news') {
        {{ data.detailObj?.name }}
      }
    </h2>
    <p class="card-description">
      @if (data.type === 'blog') {
        {{ data.detailObj?.content }}
      }
      @if (data.type === 'news') {
        {{ data.detailObj.description }}
      }
    </p>
  </div>
}